import React, { FC, useMemo } from "react"

import { Badge, BadgeProps } from "@mantine/core"

import { HealthDocument } from "../../../../contexts/health-context"
import { useLanguage } from "../../../../contexts/language-context"
import useInferStatus, { colorPerStatus } from "../../hooks/useInferStatus"

type DeviceStatusBadgeProps = BadgeProps & {
    health: HealthDocument | null
}

const DeviceStatusBadge: FC<DeviceStatusBadgeProps> = ({ health, ...props }) => {
    const { L } = useLanguage()
    const inferStatus = useInferStatus()
    const status = useMemo(() => inferStatus(health), [inferStatus, health])

    return (
        <Badge color={colorPerStatus[status] ?? "gray"} variant="filled" {...props}>
            {L(status)}
        </Badge>
    )
}

export default DeviceStatusBadge
